import React, { useCallback, useRef } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';

import { Text } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { CREATE_MEDIA } from '../../../../common/graphql/media';
import SetupPhotoSection from './SetupPhotoSection';

// Site photos picked while creating a machine or market setup. The server links
// them to the setup when the setup is created.
const SetupCreatorPlacePhotos = ({ photos, onChange, hint, error }) => {
	const styles = useThemedStyles(createStyles);
	const [createMedia] = useMutation(CREATE_MEDIA);
	const photosRef = useRef(photos);
	photosRef.current = photos;

	// Several photos can arrive before the form re-renders, so always build on the latest list.
	const setPhotos = useCallback((nextPhotos) => {
		photosRef.current = nextPhotos;
		onChange(nextPhotos);
	}, [onChange]);

	const addPhoto = useCallback(async (link) => {
		const result = await createMedia({ variables: { input: { link } } });
		setPhotos([...photosRef.current, result.data.createMedia]);
	}, [createMedia, setPhotos]);

	const removePhoto = useCallback((photo) => {
		setPhotos(photosRef.current.filter(item => item.id !== photo.id));
	}, [setPhotos]);

	return (
		<View style={styles.container}>
			<SetupPhotoSection
				title={<>Site photos<Text style={styles.required}> *</Text></>}
				photos={photos}
				onAddPhoto={addPhoto}
				onRemovePhoto={removePhoto}
				addButtonLabel="Add site photo"
			/>
			<Text style={styles.hint}>{hint}</Text>
			{error ? <Text style={styles.error}>{error}</Text> : null}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		marginTop: space.md,
	},
	required: {
		color: colors.danger,
	},
	hint: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: -space.xs,
		marginBottom: space.sm,
	},
	error: {
		...type.secondary,
		color: colors.danger,
		marginBottom: space.sm,
	},
});

export default SetupCreatorPlacePhotos;
